import React, { MutableRefObject, useEffect, useRef } from "react";
import useVaultStore from "@/stores/zustand/vault/useVaultStore";
import { Html } from "@react-three/drei";
import * as THREE from "three";
import { a, useSpring } from "@react-spring/three";
import { a as aWeb } from "@react-spring/web";
import HENGE from "@henge-inc/global-types";
import HUI from "@henge-inc/ui/v1_2";
import { i as i_v1_1 } from "@henge-inc/ui/v1_1";

interface AnnotationAddButtonProps {
  portalRef: MutableRefObject<HTMLDivElement>;
}

export const AnnotationAddButton = ({
  portalRef,
}: AnnotationAddButtonProps) => {
  const ref = useRef<THREE.Group>(null!);
  const hoverPoint = useVaultStore((state) => state.hoverPoint);

  const [{ xyz }, set] = useSpring<{ xyz: [x: number, y: number, z: number] }>(
    () => ({
      xyz: [0, 0, 0],
      config: { duration: 50 },
    }),
  );

  const shouldSnapNext = useRef(false);

  useEffect(() => {
    if (hoverPoint == null) {
      // 이후 첫 업데이트를 스냅하도록 플래그 설정
      shouldSnapNext.current = true;
      // (선택) null 동안 표시할 기본값으로 즉시 리셋
      set.start({ xyz: [0, 0, 0], immediate: true });
    } else {
      if (shouldSnapNext.current) {
        // 첫 업데이트는 스냅 (애니메이션 없음)
        set.start({ xyz: hoverPoint, immediate: true });
        shouldSnapNext.current = false;
      } else {
        // 그 다음부터는 정상적으로 애니메이션
        set.start({ xyz: hoverPoint });
      }
    }
  }, [hoverPoint, set]);

  return (
    hoverPoint && (
      <a.group ref={ref} position={xyz} visible={false}>
        <Html
          portal={portalRef}
          style={{
            pointerEvents: "none",
          }}
        >
          <aWeb.div
            className={
              "flex justify-center items-center w-6 h-6 -translate-x-1/2 -translate-y-1/2"
            }
            style={{
              border: "1.5px solid var(--text-white)",
              borderRadius: "50%",
              backgroundColor: HUI.HColour.Indigo100()
                .withOpacity(0.8)
                .getColour()
                .oklch.getCSS(),
            }}
          >
            <i_v1_1.Plus
              kind={HENGE.ICON_KIND.regular}
              size={HENGE.DETAILED_SIZE.medium}
              colour={HENGE.STATIC_COLOUR["text-white"]}
            />
          </aWeb.div>
        </Html>
      </a.group>
    )
  );
};
